import type React from 'react';

import { FacebookButton } from './components/FacebookButton';
import { GoogleButton } from './components/GoogleButton';
import { useLoginSocialButtons } from './hooks/useLoginSocialButtons';

const MAPPING = {
	facebook: FacebookButton,
	google: GoogleButton,
};

export const LoginSocialButtons: React.FC<EmptyProps> = () => {
	const {
		data: { buttons },
	} = useLoginSocialButtons();

	if (!buttons.length) return null;

	return (
		<div className="flex flex-col items-center gap-4">
			{buttons
				.map((button) => MAPPING[button])
				.map((Cmp, idx) => (
					<div
						// Setting this because google forces its button to a max width of 400px
						className="w-full max-w-sm"
						// eslint-disable-next-line react/no-array-index-key
						key={idx}
					>
						<Cmp />
					</div>
				))}
		</div>
	);
};
